
<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>

    <div class="rides-cs" style="height:406px;">
      <div class="floatR" style="height:406px;width: 150px; position:relative;">
        <div
          style="position:absolute; width:20px; height:20px; right:5px; top:5px; text-align:right;"
          class="bs"
        >
          <a id="aFloatTools_Hide" title="查看在线客服" href="javascript:void(0);">
            <img src="../static/images/q.png" />
          </a>
        </div>

        <div class="zakf">
          <div :style="{background:'url('+require('../static/images/dsa.jpg')+')'}" class="sss">
            <a
              href="http://wpa.qq.com/msgrd?v=3&site=客服&menu=yes&uin=497254175"
              target="_blank"
              style="display:block; padding-left:30px; color:#FFF;"
            >在线客服一</a>
          </div>

          <div class="ss2">
            <a
              href="http://wpa.qq.com/msgrd?v=3&site=客服&menu=yes&uin=497254175"
              target="_blank"
              style="display:block; padding-left:30px; color:#FFF;"
            >在线客服二</a>
          </div>

          <div class="ss3">
            <a
              href="http://wpa.qq.com/msgrd?v=3&site=客服&menu=yes&uin=497254175"
              target="_blank"
              style="display:block; padding-left:30px; color:#FFF;"
            >在线客服三</a>
          </div>

          <div class="ss4">
            <a
              href="http://wpa.qq.com/msgrd?v=3&site=客服&menu=yes&uin=497254175"
              target="_blank"
              style="display:block; padding-left:30px; color:#FFF;"
            >在线客服四</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/views/head";
import Footer from "@/views/footer";
export default {
  name: "App",
  data() {
    return {
    };
  },
  components: {
    Header,
    Footer
  },
  mounted() {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      window.location.href = 'http://www.wyweld.com/wap/'
    }
  }
};
</script>
<style>
.sss {
  width: 129px;
  height: 28px;
  line-height: 28px;
  position: absolute;
  top: 175px;
  left: 8px;
}
.ss2 {
  width: 129px;
  height: 28px;
  line-height: 28px;
  background: url(../static/images/dsa.jpg);
  position: absolute;
  top: 211px;
  left: 8px;
}
.ss3 {
  width: 129px;
  height: 28px;
  line-height: 28px;
  background: url(../static/images/dsa.jpg);
  position: absolute;
  top: 246px;
  left: 8px;
}
.ss4 {
  width: 129px;
  height: 28px;
  line-height: 28px;
  background: url(../static/images/dsa.jpg);
  position: absolute;
  top: 282px;
  left: 8px;
}
.fix-banner {
  margin: 0 auto;
  height: 436px;
  width: 1600px;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
